import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import "@/config";
import "@/plugins/element.js";
import vuetify from "@/plugins/vuetify";
import "@/plugins/fragment";
import "@/plugins/vee-validate";
import "@/plugins/video-player";
import BaseCreate from "@/views/base/base-create";
import BaseCreateConfirm from "@/views/base/base-create-confirm";
import BaseEdit from "@/views/base/base-edit";
import BaseEditConfirm from "@/views/base/base-edit-confirm";
import BaseIndex from "@/views/base/base-index";
import BaseShow from "@/views/base/base-show";
import BaseImport from "@/views/base/base-import";
import BaseDownload from "@/views/base/base-download";
import "@/scss/variables.scss";
import "@/plugins/vue-ctk-date-time-picker";
import 'core-js/stable';

import CoreuiVue from '@coreui/vue';
import CoreuiVueCharts from '@coreui/vue-chartjs'
import { iconsSet as icons } from './assets/icons/icons.js';

import './plugins/firebase'

Vue.use(CoreuiVue);
Vue.use(CoreuiVueCharts);

Vue.config.productionTip = false;

Vue.component("base-create", BaseCreate);
Vue.component("base-create-confirm", BaseCreateConfirm);
Vue.component("base-edit", BaseEdit);
Vue.component("base-edit-confirm", BaseEditConfirm);
Vue.component("base-index", BaseIndex);
Vue.component("base-show", BaseShow);
Vue.component("base-import", BaseImport);
Vue.component("base-download", BaseDownload);


// bootstrap
store.dispatch("auth/validate").then(() => {
  new Vue({
    router,
    store,
    vuetify,
    icons,
    render: (h) => h(App)
  }).$mount("#app");
});
